import React from 'react'
// import {FaTwitter} from "react-icons/fa"

import {BsLinkedin, BsTwitter, BsGithub} from "react-icons/bs"
// const linkedin = ()=>{
//     <a href='https://google.com'></a>
// }

const SocialMedia = () =>  (
    <div className='app__social'>
        <div>
            <a href='https://twitter.com/Mehrdad_Rahmati'>
            <BsTwitter/>
            </a>
        </div>

        <div>
            <a href='https://github.com/Mehrdadr01'>
                <BsGithub />
            </a>
        </div>
        <div>
        <a href='https://www.linkedin.com/in/mehrdad-rahmati-545b58121'>
            <BsLinkedin />

        </a>
        </div>


    </div>
  )


export default SocialMedia